import { render, staticRenderFns } from "./InviteVendors.vue?vue&type=template&id=3b598ac8&"
import script from "./InviteVendors.vue?vue&type=script&lang=js&"
export * from "./InviteVendors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports